import React from "react";

const Footer = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <footer className="bg-[#113F67] text-white py-3 mt-auto border-t border-[#34699A]">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-sm text-gray-300">
            © {new Date().getFullYear()} {companyName}. બધા અધિકારો સુરક્ષિત.
          </p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
